/**
 * Eis-Spaghetti-Textur: feine, parallele, leicht gewellte Linien.
 * Wiederkehrendes Motiv (Sektionstrenner, Fußzeile, Platzhalter) —
 * siehe technical-design.md 13.3.
 */
export function SpaghettiDivider({ hoehe = 22, farbe = 'var(--blattgold)' }: { hoehe?: number; farbe?: string }) {
  return (
    <svg
      width="100%"
      height={hoehe}
      viewBox="0 0 240 22"
      preserveAspectRatio="none"
      aria-hidden="true"
      style={{ display: 'block', opacity: 0.5 }}
    >
      {[3, 8, 13, 18].map((y) => (
        <path
          key={y}
          d={`M0 ${y} C 20 ${y - 2}, 40 ${y + 2}, 60 ${y} S 100 ${y - 2}, 120 ${y} S 160 ${y + 2}, 180 ${y} S 220 ${y - 2}, 240 ${y}`}
          fill="none"
          stroke={farbe}
          strokeWidth="1.4"
        />
      ))}
    </svg>
  );
}
